import React from 'react'
import profilePicture from '../../../../assets/images/profile-picture5.png'

const AccountDisplay = ({ toggleAccountMenuVisibility }) => {
  return (
    <div className="header-account-display" id="desktop-account-display">
      <img
        src={profilePicture}
        className="fluid-image profile-icon-right"
        alt="User Avatar"
        onClick={toggleAccountMenuVisibility}
      />
    </div>
  )
}

export default AccountDisplay
